import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthMoodleStateModel, AuthRequestModel, CommunityPathwayPayload, UserModel } from '@tsin-core/models/auth.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';
import { ConfigService } from '@tsin-core/services/common/config.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  http: HttpClient = inject(HttpClient);
  configService: ConfigService = inject(ConfigService);

  /** Runtime API base URL from config.json (falls back to compile-time env) */
  private get apiUrl(): string {
    return this.configService.getConfig().apiUrl || environment.apiUrl2;
  }

  /** Runtime Auth Service URL from config.json */
  private get authServiceUrl(): string {
    return this.configService.getAuthServiceUrl() || environment.authBaseUrl;
  }

  validate(credentials: AuthRequestModel) {
    return this.http.post(`${environment.userBaseUrl}/auth/authenticate-profiile`, credentials)
  }

  loginMoodle(payload: { email: string }): Observable<AuthMoodleStateModel> {
    return this.http.post<AuthMoodleStateModel>(`${environment.userBaseUrl}/moodle/login-url-token`, payload);
  }

  logout() {
    return this.http.delete(`${environment.userBaseUrl}/auth/authenticate-profiile`)
  }

  validateToken(token: string): Observable<UserModel> {
    return this.http.get<UserModel>(`${this.apiUrl}/user/me`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
  }

  getCurrentUser(): Observable<UserModel> {
    return this.http.get<UserModel>(`${this.apiUrl}/user/me`);
  }

  refreshToken(payload: { refreshToken: string }): Observable<{ token: string; refreshToken: string }> {
    return this.http.post<{ token: string; refreshToken: string }>(`${this.authServiceUrl}/api/auth/refresh`, payload);
  }

  /**
   * Update user's preferred language in backend (MongoDB + Cognito).
   * Mettre à jour la langue préférée de l'utilisateur (MongoDB + Cognito).
   */
  updateLanguage(language: 'en' | 'fr'): Observable<{ success: boolean; preferredLanguage: string }> {
    return this.http.patch<{ success: boolean; preferredLanguage: string }>(
      `${environment.apiUrl2}/user/language`,
      { language },
    );
  }

  /**
   * Save the applicant's PRO practice option (community-pathway page).
   * Enregistrer l'option de pratique PRO du demandeur.
   */
  updateCommunityPathway(payload: CommunityPathwayPayload): Observable<{ data: UserModel }> {
    return this.http.patch<{ data: UserModel }>(`${this.apiUrl}/user/community-pathway`, payload);
  }

}
